import { render, staticRenderFns } from "./SliderCampanha.vue?vue&type=template&id=0a668d1b"
import script from "./SliderCampanha.vue?vue&type=script&lang=js"
export * from "./SliderCampanha.vue?vue&type=script&lang=js"
import style0 from "./SliderCampanha.vue?vue&type=style&index=0&id=0a668d1b&prod&lang=scss"
import style1 from "./SliderCampanha.vue?vue&type=style&index=1&id=0a668d1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports